export default class Regex {
    static unlimitedPattern = '^Unlimited$|^\\d+$';

    static unlimitedRegex = new RegExp(Regex.unlimitedPattern);

    static decimalRegex = /\B(?=(\d{3})+(?!\d))/g;

    static commaRegex = /,/g;
}
